var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags / USA"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4839 0.642883H8.25806L0.28125 9.19991V16.3122H15.4839L16 15.8429V14.3572L15.6641 13.862V12.4573L16 12.0714V9.78572L15.6979 9.33714V7.90014L16 7.49995V5.21428L15.6979 4.80018V3.54081L16 2.9286V1.44288C16 1.00103 15.7689 0.642883 15.4839 0.642883Z",
    fill: "#E5646E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.01025 2.92859H15.9998V5.21431H8.01025V2.92859Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8 7.49994L8.25806 9.78566H16V7.49994H8Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.516125 13.4429V9.36945L0 9.78572V12.0714L0.21875 12.3605V13.862L0 14.3572V15.8429C0 16.2847 0.231094 16.6429 0.516125 16.6429H15.4839C15.7689 16.6429 16 16.2847 16 15.8429H2.06453C1.20938 15.8429 0.516125 14.7684 0.516125 13.4429Z",
    fill: "#DB4655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.25806 0.642883H0.516125L0.1875 1.44288L0.516125 9.78572H8.25806V0.642883Z",
    fill: "#5055A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M0.516125 0.642883C0.231094 0.642883 0 1.00103 0 1.44288V9.78572H0.516125V0.642883Z",
    fill: "#3F3F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M1.0347 2.42628C0.892047 2.42628 0.775391 2.24716 0.775391 2.02628C0.775391 1.8054 0.889547 1.62628 1.0322 1.62628H1.03473C1.17739 1.62628 1.2928 1.8054 1.2928 2.02628C1.2928 2.24716 1.17733 2.42628 1.0347 2.42628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M1.0347 5.62629C0.892047 5.62629 0.775391 5.44717 0.775391 5.22629C0.775391 5.00542 0.889547 4.82629 1.0322 4.82629H1.03473C1.17739 4.82629 1.2928 5.00542 1.2928 5.22629C1.2928 5.44717 1.17733 5.62629 1.0347 5.62629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M1.0347 8.82626C0.892047 8.82626 0.775391 8.64713 0.775391 8.42625C0.775391 8.20537 0.889547 8.02625 1.0322 8.02625H1.03473C1.17739 8.02625 1.2928 8.20537 1.2928 8.42625C1.2928 8.64713 1.17733 8.82626 1.0347 8.82626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M1.0347 4.02625C0.892047 4.02625 0.775391 3.84713 0.775391 3.62626C0.775391 3.40538 0.889547 3.22626 1.0322 3.22626H1.03473C1.17739 3.22626 1.2928 3.40538 1.2928 3.62626C1.29277 3.84713 1.17733 4.02625 1.0347 4.02625Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M1.0347 7.22626C0.892047 7.22626 0.775391 7.04714 0.775391 6.82627C0.775391 6.60539 0.889547 6.42627 1.0322 6.42627H1.03473C1.17739 6.42627 1.2928 6.60539 1.2928 6.82627C1.2928 7.04714 1.17733 7.22626 1.0347 7.22626Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M7.22806 2.42628C7.08541 2.42628 6.96875 2.24716 6.96875 2.02628C6.96875 1.8054 7.08291 1.62628 7.22556 1.62628H7.22809C7.37075 1.62628 7.48616 1.8054 7.48616 2.02628C7.48616 2.24716 7.37072 2.42628 7.22806 2.42628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M7.22806 5.62629C7.08541 5.62629 6.96875 5.44717 6.96875 5.22629C6.96875 5.00542 7.08291 4.82629 7.22556 4.82629H7.22809C7.37075 4.82629 7.48616 5.00542 7.48616 5.22629C7.48616 5.44717 7.37072 5.62629 7.22806 5.62629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M7.22806 8.82626C7.08541 8.82626 6.96875 8.64713 6.96875 8.42625C6.96875 8.20537 7.08291 8.02625 7.22556 8.02625H7.22809C7.37075 8.02625 7.48616 8.20537 7.48616 8.42625C7.48616 8.64713 7.37072 8.82626 7.22806 8.82626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M7.22806 4.02625C7.08541 4.02625 6.96875 3.84713 6.96875 3.62626C6.96875 3.40538 7.08291 3.22626 7.22556 3.22626H7.22809C7.37075 3.22626 7.48616 3.40538 7.48616 3.62626C7.48616 3.84713 7.37072 4.02625 7.22806 4.02625Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M7.22806 7.22626C7.08541 7.22626 6.96875 7.04714 6.96875 6.82627C6.96875 6.60539 7.08291 6.42627 7.22556 6.42627H7.22809C7.37075 6.42627 7.48616 6.60539 7.48616 6.82627C7.48616 7.04714 7.37072 7.22626 7.22806 7.22626Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M2.58304 2.42628C2.44039 2.42628 2.32373 2.24716 2.32373 2.02628C2.32373 1.8054 2.43789 1.62628 2.58054 1.62628H2.58307C2.72573 1.62628 2.84114 1.8054 2.84114 2.02628C2.84114 2.24716 2.7257 2.42628 2.58304 2.42628Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M2.58304 5.62629C2.44039 5.62629 2.32373 5.44717 2.32373 5.22629C2.32373 5.00542 2.43789 4.82629 2.58054 4.82629H2.58307C2.72573 4.82629 2.84114 5.00542 2.84114 5.22629C2.84114 5.44717 2.7257 5.62629 2.58304 5.62629Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M2.58304 8.82626C2.44039 8.82626 2.32373 8.64713 2.32373 8.42625C2.32373 8.20537 2.43789 8.02625 2.58054 8.02625H2.58307C2.72573 8.02625 2.84114 8.20537 2.84114 8.42625C2.84114 8.64713 2.7257 8.82626 2.58304 8.82626Z",
    fill: "#F2F2F6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M2.58304 4.02625C2.44039 4.02625 2.32373 3.84713 2.32373 3.62626C2.32373 3.40538 2.43789 3.22626 2.58054 3.22626H2.58307C2.72573 3.22626 2.84114 3.40538 2.84114 3.62626C2.84111 3.84713 2.7257 4.02625 2.58304 4.02625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M2.58304 7.22626C2.44039 7.22626 2.32373 7.04714 2.32373 6.82627C2.32373 6.60539 2.43789 6.42627 2.58054 6.42627H2.58307C2.72573 6.42627 2.84114 6.60539 2.84114 6.82627C2.84114 7.04714 2.7257 7.22626 2.58304 7.22626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M1.80912 3.22627C1.66646 3.22627 1.5498 3.04714 1.5498 2.82627C1.5498 2.60539 1.66396 2.42627 1.80662 2.42627H1.80915C1.9518 2.42627 2.06721 2.60539 2.06721 2.82627C2.06718 3.04719 1.95177 3.22627 1.80912 3.22627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M1.80912 6.42628C1.66646 6.42628 1.5498 6.24715 1.5498 6.02628C1.5498 5.8054 1.66396 5.62628 1.80662 5.62628H1.80915C1.9518 5.62628 2.06721 5.8054 2.06721 6.02628C2.06721 6.24715 1.95177 6.42628 1.80912 6.42628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M1.80912 4.82624C1.66646 4.82624 1.5498 4.64712 1.5498 4.42624C1.5498 4.20537 1.66396 4.02625 1.80662 4.02625H1.80915C1.9518 4.02625 2.06721 4.20537 2.06721 4.42624C2.06721 4.64712 1.95177 4.82624 1.80912 4.82624Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M1.80912 8.02631C1.66646 8.02631 1.5498 7.84719 1.5498 7.62632C1.5498 7.40544 1.66396 7.22632 1.80662 7.22632H1.80915C1.9518 7.22632 2.06721 7.40544 2.06721 7.62632C2.06721 7.84719 1.95177 8.02631 1.80912 8.02631Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M4.13138 2.42628C3.98873 2.42628 3.87207 2.24716 3.87207 2.02628C3.87207 1.8054 3.98623 1.62628 4.12888 1.62628H4.13141C4.27407 1.62628 4.38948 1.8054 4.38948 2.02628C4.38948 2.24716 4.27401 2.42628 4.13138 2.42628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M4.13138 5.62629C3.98873 5.62629 3.87207 5.44717 3.87207 5.22629C3.87207 5.00542 3.98623 4.82629 4.12888 4.82629H4.13141C4.27407 4.82629 4.38948 5.00542 4.38948 5.22629C4.38948 5.44717 4.27401 5.62629 4.13138 5.62629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M4.13138 8.82626C3.98873 8.82626 3.87207 8.64713 3.87207 8.42625C3.87207 8.20537 3.98623 8.02625 4.12888 8.02625H4.13141C4.27407 8.02625 4.38948 8.20537 4.38948 8.42625C4.38948 8.64713 4.27401 8.82626 4.13138 8.82626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M4.13138 4.02625C3.98873 4.02625 3.87207 3.84713 3.87207 3.62626C3.87207 3.40538 3.98623 3.22626 4.12888 3.22626H4.13141C4.27407 3.22626 4.38948 3.40538 4.38948 3.62626C4.38944 3.84713 4.27401 4.02625 4.13138 4.02625Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M4.13138 7.22626C3.98873 7.22626 3.87207 7.04714 3.87207 6.82627C3.87207 6.60539 3.98623 6.42627 4.12888 6.42627H4.13141C4.27407 6.42627 4.38948 6.60539 4.38948 6.82627C4.38948 7.04714 4.27401 7.22626 4.13138 7.22626Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M3.35746 3.22627C3.2148 3.22627 3.09814 3.04714 3.09814 2.82627C3.09814 2.60539 3.2123 2.42627 3.35496 2.42627H3.35749C3.50014 2.42627 3.61555 2.60539 3.61555 2.82627C3.61555 3.04719 3.50011 3.22627 3.35746 3.22627Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M3.35746 6.42628C3.2148 6.42628 3.09814 6.24715 3.09814 6.02628C3.09814 5.8054 3.2123 5.62628 3.35496 5.62628H3.35749C3.50014 5.62628 3.61555 5.8054 3.61555 6.02628C3.61555 6.24715 3.50011 6.42628 3.35746 6.42628Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M3.35746 4.82624C3.2148 4.82624 3.09814 4.64712 3.09814 4.42624C3.09814 4.20537 3.2123 4.02625 3.35496 4.02625H3.35749C3.50014 4.02625 3.61555 4.20537 3.61555 4.42624C3.61555 4.64712 3.50011 4.82624 3.35746 4.82624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M3.35746 8.02631C3.2148 8.02631 3.09814 7.84719 3.09814 7.62632C3.09814 7.40544 3.2123 7.22632 3.35496 7.22632H3.35749C3.50014 7.22632 3.61555 7.40544 3.61555 7.62632C3.61555 7.84719 3.50011 8.02631 3.35746 8.02631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M5.67728 2.42628C5.53463 2.42628 5.41797 2.24716 5.41797 2.02628C5.41797 1.8054 5.53213 1.62628 5.67478 1.62628H5.67731C5.81997 1.62628 5.93538 1.8054 5.93538 2.02628C5.93538 2.24716 5.81994 2.42628 5.67728 2.42628Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M5.67728 5.62629C5.53463 5.62629 5.41797 5.44717 5.41797 5.22629C5.41797 5.00542 5.53213 4.82629 5.67478 4.82629H5.67731C5.81997 4.82629 5.93538 5.00542 5.93538 5.22629C5.93538 5.44717 5.81994 5.62629 5.67728 5.62629Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M5.67728 8.82626C5.53463 8.82626 5.41797 8.64713 5.41797 8.42625C5.41797 8.20537 5.53213 8.02625 5.67478 8.02625H5.67731C5.81997 8.02625 5.93538 8.20537 5.93538 8.42625C5.93538 8.64713 5.81994 8.82626 5.67728 8.82626Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M5.67728 4.02625C5.53463 4.02625 5.41797 3.84713 5.41797 3.62626C5.41797 3.40538 5.53213 3.22626 5.67478 3.22626H5.67731C5.81997 3.22626 5.93538 3.40538 5.93538 3.62626C5.93534 3.84713 5.81994 4.02625 5.67728 4.02625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M5.67728 7.22626C5.53463 7.22626 5.41797 7.04714 5.41797 6.82627C5.41797 6.60539 5.53213 6.42627 5.67478 6.42627H5.67731C5.81997 6.42627 5.93538 6.60539 5.93538 6.82627C5.93538 7.04714 5.81994 7.22626 5.67728 7.22626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M4.90336 3.22627C4.7607 3.22627 4.64404 3.04714 4.64404 2.82627C4.64404 2.60539 4.7582 2.42627 4.90086 2.42627H4.90339C5.04604 2.42627 5.16145 2.60539 5.16145 2.82627C5.16142 3.04719 5.04601 3.22627 4.90336 3.22627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M4.90336 6.42628C4.7607 6.42628 4.64404 6.24715 4.64404 6.02628C4.64404 5.8054 4.7582 5.62628 4.90086 5.62628H4.90339C5.04604 5.62628 5.16145 5.8054 5.16145 6.02628C5.16145 6.24715 5.04601 6.42628 4.90336 6.42628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M4.90336 4.82624C4.7607 4.82624 4.64404 4.64712 4.64404 4.42624C4.64404 4.20537 4.7582 4.02625 4.90086 4.02625H4.90339C5.04604 4.02625 5.16145 4.20537 5.16145 4.42624C5.16145 4.64712 5.04601 4.82624 4.90336 4.82624Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M4.90336 8.02631C4.7607 8.02631 4.64404 7.84719 4.64404 7.62632C4.64404 7.40544 4.7582 7.22632 4.90086 7.22632H4.90339C5.04604 7.22632 5.16145 7.40544 5.16145 7.62632C5.16145 7.84719 5.04601 8.02631 4.90336 8.02631Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M6.45414 3.22627C6.31148 3.22627 6.19482 3.04714 6.19482 2.82627C6.19482 2.60539 6.30898 2.42627 6.45164 2.42627H6.45417C6.59682 2.42627 6.71223 2.60539 6.71223 2.82627C6.7122 3.04719 6.59679 3.22627 6.45414 3.22627Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M6.45414 6.42628C6.31148 6.42628 6.19482 6.24715 6.19482 6.02628C6.19482 5.8054 6.30898 5.62628 6.45164 5.62628H6.45417C6.59682 5.62628 6.71223 5.8054 6.71223 6.02628C6.71223 6.24715 6.59679 6.42628 6.45414 6.42628Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M6.45414 4.82624C6.31148 4.82624 6.19482 4.64712 6.19482 4.42624C6.19482 4.20537 6.30898 4.02625 6.45164 4.02625H6.45417C6.59682 4.02625 6.71223 4.20537 6.71223 4.42624C6.71223 4.64712 6.59679 4.82624 6.45414 4.82624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M6.45414 8.02631C6.31148 8.02631 6.19482 7.84719 6.19482 7.62632C6.19482 7.40544 6.30898 7.22632 6.45164 7.22632H6.45417C6.59682 7.22632 6.71223 7.40544 6.71223 7.62632C6.71223 7.84719 6.59679 8.02631 6.45414 8.02631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M0.09375 13.6965L0.633125 14.3571H16V12.0714H0.516125L0.09375 13.6965Z",
    fill: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M0 12.0715V14.3572H0.633125C0.558094 14.0753 0.516156 13.7668 0.516156 13.4429V12.0714H0L0 12.0715Z",
    fill: "#E1E1E6"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_9"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.642883,
    width: 16,
    height: 16,
    rx: 1,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.f9967da40acc4ee21048766924663872.svg";
export { ForwardRef as ReactComponent };